export function calculateRoundOff(amount) {
    // Ensure grandTotal is a float and amountToBePaid is an integer
    let grandTotal = parseFloat(amount);
    let amountToBePaid = parseInt(amount, 10);

    // Calculate the round-off
    const roundOff = amountToBePaid - grandTotal;

    // Round to 2 decimal places to avoid floating-point precision issues
    return Math.round(roundOff * 100) / 100;
}